import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NewOrderComponent } from '../new-order.component';

@Component({
  selector: 'app-new-know-your-customer',
  templateUrl: './new-know-your-customer.component.html',
  styleUrl: './new-know-your-customer.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NewKnowYourCustomerComponent extends NewOrderComponent {

}
